import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 96 48", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "#C10000" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h96v48H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 0h40v24H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M17 3h6v18h-6z" }), /* @__PURE__ */ React.createElement("path", { d: "M11 9h18v6H11z" })));
const ForwardRef = forwardRef(SvgTo);
const Memo = memo(ForwardRef);
export default Memo;
